import { observer } from "mobx-react-lite";
import { Flex, Typography } from "antd";

import { EntityTypeTabs } from "./EntityTypeTabs";

export const PendingActionsPage = observer(() => {
  return (
    <Flex vertical gap="large">
      <Typography.Title className="margin-none">Ожидают действий</Typography.Title>
      <EntityTypeTabs />
    </Flex>
  );
});
